<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Article</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Edit Article</h5>
      <br />
      <br />
      <b-row>
        <b-col>
          <div>
            <b-tabs content-class="mt-3" justified>
              <b-tab
                title="Shipment"
                :active="items.type == 'shipment'"
                :disabled="items.type != 'shipment'"
              >
                <app-shipment :reasonList="reasonList" :items="items"></app-shipment>
              </b-tab>
              <b-tab title="FM" :active="items.type == 'fm'" :disabled="items.type != 'fm'">
                <app-fm :reasonList="reasonList" :items="items"></app-fm>
              </b-tab>
              <b-tab title="LM" :active="items.type == 'lm'" :disabled="items.type != 'lm'">
                <app-lm :reasonList="reasonList" :items="items"></app-lm>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Shipment from '../component/rate/editShipment';
import FM from '../component/rate/editFM';
import LM from '../component/rate/editLM';

export default {
  components: {
    appShipment: Shipment,
    appFm: FM,
    appLm: LM,
  },
  data() {
    return {
      items: [],
      reasonList: [],
    };
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    this.$store.dispatch('RatingModule/getReasons');
    this.$store.dispatch('RatingModule/getRate', this.$route.params.id);
  },
  created() {
    this.$store.watch(
      state => state.RatingModule.rate_id,
      (newValue, oldValue) => {
        this.items = newValue;
      },
    );
    this.$store.watch(
      state => state.RatingModule.reason,
      (newValue, oldValue) => {
        this.reasonList = newValue;
      },
    );
  },
  methods: {},
};
</script>

<style scoped>
</style>
